import React from 'react'
import { View } from 'react-native'
import tw from 'tailwind-rn'
import CrossPlatformImage from '../CrossPlatformImage'

// const tkLogo = require('../../../assets/img/logo/tk-logo.png')
const slaekLogo = require('../../../assets/img/logo/logo-slaek.png')
const slaekLogo2x = require('../../../assets/img/logo/logo-slaek_2x.png')
const slaekLogo3x = require('../../../assets/img/logo/logo-slaek_3x.png')
const thlaekLogo = require('../../../assets/img/logo/logo-lak-thueringen.png')
const thlaekLogo2x = require('../../../assets/img/logo/logo-lak-thueringen_2x.png')
const thlaekLogo3x = require('../../../assets/img/logo/logo-lak-thueringen_3x.png')
const tkLogo = require('../../../assets/img/logo/tk-logo.png')
const tkLogo2x = require('../../../assets/img/logo/tk-logo_2x.png')
const tkLogo3x = require('../../../assets/img/logo/tk-logo_3x.png')

const Cooperation = (): React.ReactElement => {
  return (
    <View style={tw('pt-10 pb-3')}>
      <View style={tw('flex-row justify-center items-center')}>
        <View style={tw('pr-5')}>
          <CrossPlatformImage
            source={thlaekLogo}
            source2x={thlaekLogo2x}
            source3x={thlaekLogo3x}
            alt="Landesärztekammer Thüringen Logo"
          />
        </View>

        <View style={tw('pl-5')}>
          <CrossPlatformImage
            source={slaekLogo}
            source2x={slaekLogo2x}
            source3x={slaekLogo3x}
            alt="Sächsische Landesärztekammer Logo"
          />
        </View>
      </View>
      <View style={tw('mt-5 flex-row justify-center items-center')}>
        <View style={tw('')}>
          <CrossPlatformImage
            source={tkLogo}
            source2x={tkLogo2x}
            source3x={tkLogo3x}
            alt="Landesärztekammer Thüringen Logo"
          />
        </View>
      </View>
    </View>
  )
}

Cooperation.propTypes = {}

export default Cooperation
